const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const fetchSubscriptions = async (filters = {}) => {
    try {
      const token = localStorage.getItem('authToken');
      const query = new URLSearchParams(filters).toString();
      const response = await fetch(
        `${BASE_URL}/eci/apis/v4/subscriptions/getall_subscription?${query}`,{
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          }
        });
  
      if (!response.ok) {
        throw new Error('Failed to fetch subscriptions');
      }
  
      const data = await response.json();
      return data.msg || [];
    } catch (error) {
      console.error('Error fetching subscriptions:', error);
      return [];
    }
  };
  